import EvChargers from "../../pages/EvChargers"

export default function Panel() {
  return (
    <EvChargers />
  )
}
